<proffeo-ui-choice-group
  (valueChange)="onValueChange($event)"
  [value]="selectedValue()"
  [options]="options"
  [compareWith]="compareTimeValues"
  [columns]="5"
  [translateLabels]="false"
/>
